namespace Matrix.Indexation {
    export interface IndexationProfileSecurityForm {
        SecurityId: Serenity.ServiceLookupEditor;
        IndexCode: FormatLookupEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class IndexationProfileSecurityForm extends Serenity.PrefixedContext {
        static formKey = 'Indexation.IndexationProfileSecurity';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IndexationProfileSecurityForm.init)  {
                IndexationProfileSecurityForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(IndexationProfileSecurityForm, [
                    'SecurityId', w0,
                    'IndexCode', w1,
                    'DefaultSortOrder', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
